import { z } from '@betty/toolkit/api';

export const PromoContentTypeSchema = z.enum(['Referrer', 'Referee']);

export const PromoTypeSchema = z.enum([
  'Welcome',
  'Action',
  'Static',
  'Cashback',
  'Streaks',
  'InPeriod',
  'InstantReward',
]);

export const PromoCTASchema = z.enum([
  'LaunchDeposit',
  'LaunchGame',
  'NavigationReferral',
  'NavigationRegister',
  'NavigationLobby',
  'NavigationRewards',
  'NavigationGiftbox',
  'NavigationPromotions',
  'NavigationPromoDetails',
  'NavigationQuestDetails',
  'RedeemLoyaltyReward',
  'RedeemDailyGift',
]);

export const PromoTargetSchema = z.enum([
  'Bonus',
  'Cash',
  'Coins',
  'FreeSpins',
  'InstantWheel',
]);

const SubTypeMetaSchema = z.object({
  referrerName: z.string().optional(),
  referrerId: z.number().optional(),
  currentAccumulation: z.number().optional(),
  targetAccumulation: z.number().optional(),
  expiryDate: z.string().optional(),
  gameIds: z.array(z.number()).optional(),
  startDate: z.string().optional(),
  minimumQualificationAmount: z.number().optional(),
  percentage: z.number().optional(),
  maximumRewardAmount: z.number().optional(),
  isInLadderPromotion: z.boolean().optional(),
});

const ReferrerTargetSchema = z.enum([
  'Bonus',
  'Cash',
  'Coins',
  'Welcome',
  'FreeSpins',
  'BettyPoints',
]);

const ReferrerDataSchema = z.object({
  amount: z.optional(z.number()),
  target: z.optional(ReferrerTargetSchema),
  referrerName: z.optional(z.string()),
});

export const PromotionRewardSchema = z.object({
  rewardTarget: PromoTargetSchema,
  rewardAmount: z.number(),
});

export const PromoStatusSchema = z.enum([
  'Future',
  'Available',
  'Locked',
  'OptIn',
]);

export const PromoSchema = z.object({
  promotionId: z.number(),
  rewardAmount: z.optional(z.number()),
  rewardTarget: z.optional(PromoTargetSchema),
  promoType: z.optional(PromoTypeSchema),
  title: z.optional(z.string()),
  cta: z.optional(
    z.object({
      type: PromoCTASchema,
      gameId: z.optional(z.number()),
    }),
  ),
  ctaActionLabel: z.optional(z.string()),
  ctaInfoLabel: z.optional(z.string()),
  isBanner: z.optional(z.boolean()),
  bannerImageUrl: z.optional(z.string()),
  endDate: z.optional(z.string()),
  startDate: z.optional(z.string()),
  miniImageUrl: z.optional(z.string()),
  imageUrl: z.optional(z.string()),
  link: z.optional(z.string()),
  shortDescription: z.optional(z.string()),
  longDescription: z.optional(z.string()),
  termsAndConditions: z.optional(z.string()),
  subPromoType: z.optional(z.string()),
  subTypeMeta: z.optional(SubTypeMetaSchema),
  gameId: z.optional(z.number()),
  refData: z.optional(ReferrerDataSchema),
  rewards: z.array(PromotionRewardSchema),
  rewardDescription: z.optional(z.string()),
  urlName: z.optional(z.string()),
  contentType: z.optional(PromoContentTypeSchema),
  referralCode: z.optional(z.string()),
  isOptedIn: z.optional(z.boolean()),
  searchEngineTitle: z.optional(z.string()),
  searchEngineDescription: z.optional(z.string()),
  lockedDescription: z.optional(z.string()),
  status: z.optional(PromoStatusSchema),
  isFuture: z.optional(z.boolean()),
  isAvailable: z.optional(z.boolean()),
  isLocked: z.optional(z.boolean()),
  isCompleted: z.optional(z.boolean()),
  isDepositAction: z.optional(z.boolean()),
  rewardLabel: z.optional(z.string()),
});

export const ExtendedPromotionSchema = PromoSchema.extend({
  slug: z.string(),
});
